import React, { useEffect, useMemo, useState } from 'react';
import TableComponent from 'app/components/TableComponent';
import { Modal } from 'react-bootstrap-v5';
import './styles/usuarios.css';
import { KTSVG } from '_metronic/helpers/components/KTSVG';
import { InputModalText } from 'app/components/InputsComponents/InputModalText';
import { InputModalSelect } from 'app/components/InputsComponents/InputModalSelect';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getAllUsers, getAllUsersFilter, usuarioCreateAndUpdate } from 'app/service/configuration/Users';
import { User } from 'app/types/users';
import { FilterView } from 'app/components/FilterView';
import { getAllDepartmentsFilterDesc } from 'app/service/configuration/Departamentos';
import { getCompany, getRoles } from 'app/service/catalog/Catalogs';
import { DefaultCatalogRecord } from 'app/types/commons';
import { PatternFormat } from 'react-number-format';

const heads = [
    { code: 'name', label: 'Nombre Completo' },
    { code: 'correo', label: 'Email' },
    { code: 'celular', label: 'Celular' },
    { code: 'telefono', label: 'Teléfono' },
    { code: 'rol', label: 'Rol' },
    { code: 'userName', label: 'Usuario' },
];

const UsuariosView: React.FC = () => {
    const [loadingGrid, setLoadingGrid] = useState<boolean>(true);
    const [show, setShow] = useState<boolean>(false);
    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
    const [visivility, setVisivility] = useState<boolean>(false);
    const [submitWithoutStatusValidation, setSubmitWithoutStatusValidation] = useState(false);

    const [isFiltered, setIsFiltered] = useState<boolean>(false);
    const [employeeName, setEmployeeName] = useState<string>('');
    const [employeeNumber, setEmployeeNumber] = useState<string>('');
    const [selectedOption, setSelectedOption] = useState<string>('');
    const [selectOptionsCompanies, setSelectOptionsCompanies] = useState<any[]>([]);

    const [selectOptionsRoles, setSelectOptionsRoles] = useState<DefaultCatalogRecord[]>([]);
    const [users, setUsers] = useState<User[]>([]);
    const [id, setId] = useState<number | undefined | null>(null);

    //Por default siempre sera uno el id Persona que es "PERSONA FÍSICA"
    const [idTypePersona, setIdTypePersona] = useState<number>(1);
    const [idCompany, setIdCompany] = useState<number | undefined | null>(null);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const fetchCompanies = async (): Promise<void> => {
        try {
            const res = await getCompany();
            setSelectOptionsCompanies(res.records.map((record: any) => ({
                id: record.id, description: record.description
            })));

        } catch (err) {
            console.error("Error fetching companies", err);
        }
    }

    const fetchUsers = async (): Promise<void> => {
        try {
            setLoadingGrid(true);
            const resUsers = await getAllUsers(currentPage, pageSize);
            const resRoles = await getRoles();

            setSelectOptionsRoles(resRoles.records.map((record) => ({
                ...record,
                id: record.id,
                description: record.description
            })));

            setUsers((resUsers!.records ?? []).map((record) => ({
                ...record,
            })));

            setTotalRecords(resUsers!.totalRecords ?? []);
        } catch (err) {
            console.error("Error fetching users", err);
        } finally {
            setLoadingGrid(false);
        }
    }

    const RolesSchema = Yup.object().shape({
        name: Yup.string()
            .required('Este campo es requerido')
            .min(3, "Mínimo 3 caracteres")
            .max(15, "Máximo 15 caracteres")
            .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/, "Solo se permiten letras y espacios"),

        fatherLastName: Yup.string()
            .required('Este campo es requerido')
            .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/, "Solo se permiten letras y espacios"),

        motherLastName: Yup.string()
            .required('Este campo es requerido')
            .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/, "Solo se permiten letras y espacios"),
        correo: Yup.string().email('Correo inválido').required('Este campo es requerido'),
        correoPersonal: Yup.string().email('Correo inválido').required('Este campo es requerido'),
        rol: Yup.number()
            .required('Este campo es requerido')
            .notOneOf([0], "Seleccione una opción"),
        company: Yup.number()
            .required('Este campo es requerido')
            .notOneOf([0], "Seleccione una opción"),
        celular: Yup.string()
            .trim()
            .test('min-length', 'Mínimo 10 dígitos', value =>
                value ? value.replace(/\s+/g, '').length >= 10 : false
            )
            .test('max-length', 'Máximo 10 dígitos', value =>
                value ? value.replace(/\s+/g, '').length <= 10 : false
            )
            .required('Este campo es requerido.'),
        telefono: Yup.string()
            .trim()
            .test('min-length', 'Mínimo 10 dígitos', value =>
                value ? value.replace(/\s+/g, '').length >= 10 : false
            )
            .test('max-length', 'Máximo 10 dígitos', value =>
                value ? value.replace(/\s+/g, '').length <= 10 : false
            )
            .required('Este campo es requerido.'),
        userName: Yup.string().required('Este campo es requerido'),
        contraseña: Yup.string()
            .when([], {
                is: () => !submitWithoutStatusValidation,
                then: Yup.string()
                    .required('Este campo es requerido')
                    .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,64}$/,
                        "El password debe contener al menos una mayúscula, una minúscula, un número, un carácter especial y tener una longitud de 8 a 64 caracteres"
                    ),
                otherwise: Yup.string(),
            }),
    });

    const formPerfil = useFormik<any>({
        validationSchema: RolesSchema,
        initialValues: {
            name: '',
            fatherLastName: '',
            motherLastName: '',
            correo: '',
            correoPersonal: '',
            rol: 0, //select
            company: 0, //select
            telefono: '',
            celular: '',
            userName: '',
            contraseña: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            const { name, fatherLastName, motherLastName, correo, correoPersonal, rol, telefono, celular, userName, company } = values;

            let { contraseña } = values;
            if (contraseña === "*****") {
                contraseña = '';
            }

            try {
                await usuarioCreateAndUpdate(
                    {
                        ...values,
                        id: id,
                        idTypePerson: idTypePersona,
                        mobile: String(celular).replaceAll(' ', ''),
                        phone: String(telefono).replaceAll(' ', ''),
                        personalMail: correoPersonal,
                        name: name,
                        paternalSurname: fatherLastName,
                        maternalSurname: motherLastName,
                        fatherLastName: fatherLastName,
                        motherLastName: motherLastName,
                        email: correo,
                        password: contraseña,
                        user: {
                            userName: userName,
                            password: contraseña,
                            email: correo,
                            companyId: Number(company),
                            rolId: Number(rol)
                        },
                        persona: {
                            idTypePerson: idTypePersona,
                            mobile: String(celular).replaceAll(' ', ''),
                            phone: String(telefono).replaceAll(' ', ''),
                            personalMail: correoPersonal,
                            id: id,
                            fullName: `${name} ${fatherLastName} ${motherLastName}`
                        }
                    }
                );

                setEmployeeName('');
                setEmployeeNumber('');
                setSelectedOption('');
                setIsFiltered(false);

                handleClose();
                fetchUsers();
                fetchCompanies();
            } catch (err) {
                console.error('Error', err);
            } finally {
                setSubmitting(false);
            }
            formPerfil.resetForm();
            handleClose();
        },
    });

    useEffect(() => {
        if (isFiltered) {
            if (selectedOption === '1' && employeeName) {
                getAllUsersFilter(currentPage, pageSize, employeeName).then(res => {
                    if (res === null) {
                        setTotalRecords(0);
                        return setUsers([]);
                    }
                    setUsers((res!.records ?? []).map((record) => ({
                        ...record,
                    })));
                    setTotalRecords(res!.totalRecords ?? 0);
                });
            }
        } else {
            fetchUsers();
            fetchCompanies();
        }
    }, [currentPage, pageSize, isFiltered, employeeName]);

    const rows = useMemo(() => {
        if (!loadingGrid && users.length) {
            return users.map((row) => ({
                name: (
                    <div
                        onClick={() => {
                            handleShow();
                            formPerfil.setValues({
                                name: row.name ?? 'N/A',
                                fatherLastName: row.fatherLastName ?? 'N/A',
                                motherLastName: row.motherLastName ?? 'N/A',
                                correo: row.correo ?? 'N/A',
                                correoPersonal: row.person.personalMail ?? "N/A",
                                rol: row.roles?.[0]?.userRole?.id ?? 0,
                                celular: row.person.celPhone ? row.person.celPhone : '',
                                telefono: row.person.phone ? row.person.phone : '',
                                userName: row.userName ?? "N/A",
                                contraseña: "*****",
                                company: row.idCompany,
                            });
                            setId(row.id);
                            setIdTypePersona(row.person.idTypePerson);
                            setIdCompany(row.idCompany);
                            setSubmitWithoutStatusValidation(true);
                        }}
                        style={{ cursor: 'pointer', color: 'blue' }}
                    >
                        {row.completeName}
                    </div>
                ),
                correo: (
                    <div style={{ textAlign: "center" }}>
                        {row.correo ?? 'N/A'}
                    </div>
                ),
                celular: (
                    <div style={{ textAlign: "center" }}>
                        {row.person.celPhone
                            ? row.person.celPhone.replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3")
                            : 'N/A'}
                    </div>
                ),
                telefono: (
                    <div style={{ textAlign: "center" }}>
                        {row.person.phone
                            ? row.person.phone.replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3")
                            : 'N/A'}
                    </div>
                ),
                rol: (
                    <div style={{ textAlign: "center" }}>
                        {row.roles?.[0]?.userRole?.description ?? 'N/A'}
                    </div>
                ),
                userName: (
                    <div style={{ textAlign: "center" }}>
                        {row.userName}
                    </div>
                ),
            }));
        }
        return [];
    }, [loadingGrid, users]);

    const validateVisibility = () => {
        setVisivility((prev) => !prev);
    };

    const handleClose = () => {
        setId(null);
        setIdTypePersona(1);
        setIdCompany(null);
        setShow(false);
        formPerfil.resetForm();
    };

    const handleShow = () => {
        setId(null);
        setIdTypePersona(1);
        setIdCompany(null);
        setShow(true);
    };

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOption(e.target.value);
    };

    const toggleFilterModal = () => {
        setId(null);
        setIdTypePersona(1);
        setIdCompany(null);
        setShowFilterModal((prev) => !prev);
    };

    return (
        <div className="row gy-5 g-xl-8">
            <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
                <div className="card card-flush p-5">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <h3 className="fw-bold fs-4">Usuarios</h3>
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-light-primary border-btn"
                                onClick={() => { setSubmitWithoutStatusValidation(false); handleShow(); }}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/abstract/abs011.svg"
                                    className="svg-icon-2 svg-icon-gray-500 "
                                />
                            </button>
                            <button className="btn btn-light-primary border-btn w-10" onClick={toggleFilterModal}>
                                <KTSVG
                                    path="/media/icons/duotune/general/gen021.svg"
                                    className="svg-icon-5 svg-icon-gray-500"
                                />
                                <span className="ms-2">Filtrar</span>
                            </button>
                        </div>
                    </div>
                    <TableComponent
                        heads={heads}
                        rows={rows}
                        rowsPerPage={pageSize}
                        page={currentPage}
                        totalRows={totalRecords}
                        setPage={setCurrentPage}
                    />
                </div>
            </div>

            {/* Modal para usuarios */}
            <Modal
                id="kt_modal_perfiles"
                tabIndex={-1}
                dialogClassName="modal-lg"
                show={show}
                onHide={handleClose}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="text-muted">Usuarios</h1>
                        <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                            <KTSVG className="svg-icon-2" path="/media/icons/duotune/arrows/arr061.svg" />
                        </div>
                    </div>
                    <div className="modal-body mx-5">
                        <form className="form" noValidate onSubmit={formPerfil.handleSubmit}>
                            <div className="row">
                                {/* Primera columna */}
                                <div className="col-md-4">
                                    <InputModalText formFormik={formPerfil} label={'Nombre'} htmlFor={'name'} name={'name'} placeholder={'Ingrese el nombre'} width='100' styleBootstrapClasses='mb-3' tabIndex={1} />
                                    <InputModalText formFormik={formPerfil} label={'Correo'} htmlFor={'correo'} name={'correo'} placeholder={'Ingrese el correo'} width='100' styleBootstrapClasses='mb-3' tabIndex={4} />
                                    <div className={`w-100 mb-3 container__modal--input`} >
                                        <label htmlFor="celular" className="form-label">
                                            Celular
                                        </label>

                                        <PatternFormat
                                            {...formPerfil.getFieldProps('celular')}
                                            className="form-control"
                                            format="## #### #####"
                                            placeholder='## #### ####'
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                formPerfil.setFieldValue('celular', value);
                                            }}
                                            tabIndex={8}
                                        />
                                        {formPerfil.touched.celular &&
                                            formPerfil.errors.celular && (
                                                <div className="fv-plugins-message-container text-danger w-100">
                                                    <span role="alert">{formPerfil.errors.celular}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <InputModalText formFormik={formPerfil} label={'Usuario'} htmlFor={'userName'} name={'userName'} placeholder={'Ingrese el usuario'} width='100' styleBootstrapClasses='mb-3' tabIndex={10} />
                                </div>
                                {/* Segunda columna */}
                                <div className="col-md-4">
                                    <InputModalText formFormik={formPerfil} label={'Apellido Paterno'} htmlFor={'fatherLastName'} name={'fatherLastName'} placeholder={'Ingrese el apellido paterno'} width='100' styleBootstrapClasses='mb-3' tabIndex={2} />
                                    <InputModalText formFormik={formPerfil} label={'Correo Personal'} htmlFor={'correoPersonal'} name={'correoPersonal'} placeholder={'Ingrese el correo personal'} width='100' styleBootstrapClasses='mb-3' tabIndex={5} />
                                    <div className={`w-100 mb-3 container__modal--input`} >
                                        <label htmlFor="telefono" className="form-label">
                                            Teléfono
                                        </label>

                                        <PatternFormat
                                            {...formPerfil.getFieldProps('telefono')}
                                            className="form-control"
                                            format="## #### #####"
                                            placeholder='## #### ####'
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                formPerfil.setFieldValue('telefono', value);
                                            }}
                                            tabIndex={8}
                                        />
                                        {formPerfil.touched.telefono &&
                                            formPerfil.errors.telefono && (
                                                <div className="fv-plugins-message-container text-danger w-100">
                                                    <span role="alert">{formPerfil.errors.telefono}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <InputModalText formFormik={formPerfil} label={'Contraseña'} htmlFor={'contraseña'} name={'contraseña'} placeholder={'Ingrese la contraseña'} width='100' styleBootstrapClasses='mb-3' tabIndex={11} />
                                </div>
                                {/* Tercera columna */}
                                <div className="col-md-4">
                                    <InputModalText formFormik={formPerfil} label={'Apellido Materno'} htmlFor={'motherLastName'} name={'motherLastName'} placeholder={'Ingrese el apellido materno'} width='100' styleBootstrapClasses='mb-3' tabIndex={3} />
                                    <InputModalSelect formFormik={formPerfil} label={'Rol'} htmlFor={'rol'} name={'rol'} width='100' styleBootstrapClasses='mb-3' selectOptions={selectOptionsRoles} tabIndex={6} />
                                    {/* Compañia */}
                                    <InputModalSelect
                                        selectOptions={selectOptionsCompanies}
                                        formFormik={formPerfil}
                                        label={'Compañia'}
                                        htmlFor={'company'}
                                        name={'company'}
                                        width='100'
                                        styleBootstrapClasses='mb-5'
                                        tabIndex={9}
                                    />
                                </div>
                            </div>
                            {/* Botones */}
                            <div className="d-flex justify-content-between mt-4">
                                <button type="button" className="btn btn-secondary" style={{ backgroundColor: '#f5f5f5', color: '#000' }} onClick={handleClose}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-danger" style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}>
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>

            {/* Modal para el Filtro */}
            <Modal
                id="kt_modal_filter"
                tabIndex={-1}
                dialogClassName="modal-dialog"
                show={showFilterModal}
                onHide={toggleFilterModal}
            >
                {showFilterModal && (
                    <FilterView
                        handleFilterClose={toggleFilterModal}
                        handleSelectChange={handleSelectChange}
                        selectedOption={selectedOption}
                        employeeName={employeeName}
                        employeeNumber={employeeNumber}
                        setEmployeeName={setEmployeeName}
                        setEmployeeNumber={setEmployeeNumber}
                        setSelectedOption={setSelectedOption}
                        setCurrentPage={setCurrentPage}
                        setIsFiltered={setIsFiltered}
                        fetchData={() => fetchUsers()}
                        fetchFilterData={() => getAllUsersFilter(currentPage, pageSize, employeeName)}
                        fetchFilterData2={() => getAllDepartmentsFilterDesc(currentPage, pageSize, employeeNumber)}
                        nameOptions={["Nombre", "Descripcion"]}
                        showSelect={false}
                    />
                )}
            </Modal>
        </div>
    );
};

export { UsuariosView };